import { render, staticRenderFns } from "./CategoriesBlock.vue?vue&type=template&id=dea4d7b2&scoped=true&"
import script from "./CategoriesBlock.vue?vue&type=script&lang=ts&"
export * from "./CategoriesBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CategoriesBlock.vue?vue&type=style&index=0&id=dea4d7b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4d7b2",
  null
  
)

export default component.exports